const LPV2Future = () => {

    return (
        <div className="lpv2-block"></div>
    )
}

export default LPV2Future